(function(){
  var GIFT_ID = 47911544422561;
  var lock = false;
  var lastSig = '';

  function pairs(cart){var q=0;cart.items.forEach(function(i){if(i.variant_id!==GIFT_ID)q+=i.quantity;});return q;}
  function giftLine(cart){return cart.items.filter(function(i){return i.variant_id===GIFT_ID;})[0];}
  function money(c){var cur=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'';var s=cur==='EUR'?'\u20AC':cur==='GBP'?'\u00A3':'$';return s+(c/100).toFixed(2);}

  function paint(cart){
    var qty=pairs(cart);
    var box=document.getElementById('ssco');
    if(box){
      var fill=document.getElementById('sscoFill');
      var msg=document.getElementById('sscoMsg');
      var pct=qty>=4?100:qty>=3?66:qty>=2?33:(qty>=1?16:0);
      if(fill)fill.style.width=pct+'%';
      box.querySelectorAll('.ssco-step').forEach(function(st){
        st.classList.toggle('on',qty>=parseInt(st.getAttribute('data-step'),10));
      });
      if(msg){
        if(qty>=4)msg.innerHTML='Maximum unlocked: <b>+30% off your order</b>';
        else if(qty===3)msg.innerHTML='<b>+25% off</b> unlocked. Add 1 more for <b>+30% off</b>';
        else if(qty===2)msg.innerHTML='<b>+20% off</b> unlocked. Add 1 more for <b>+25% off</b>';
        else if(qty===1)msg.innerHTML='Add 1 more pair and unlock <b>+20% off your order</b>';
        else msg.innerHTML='Add 2 pairs and unlock <b>+20% off your order</b>';
      }
    }
    var sav=document.getElementById('sscoSav');
    if(sav){
      var d=cart.total_discount||0;
      var v=sav.querySelector('.ssco-sav-val');
      if(d>0){v.textContent='-'+money(d);sav.style.display='flex';}else{sav.style.display='none';}
    }
  }

  function reloadDrawer(){
    fetch(window.location.pathname+'?sections=cart-drawer-section',{cache:'no-store'})
      .then(function(r){return r.json();})
      .then(function(data){
        var html=data['cart-drawer-section'];
        if(!html){ read(); return; }
        var doc=new DOMParser().parseFromString(html,'text/html');
        var novo=doc.querySelector('cart-drawer-component');
        var atual=document.querySelector('cart-drawer-component');
        if(novo&&atual&&novo.innerHTML!==atual.innerHTML){
          atual.style.transition='none';
          atual.innerHTML=novo.innerHTML;
        }
        setTimeout(read,120);
      })
      .catch(function(){ setTimeout(read,250); });
  }

  function syncGift(cart){
    if(lock) return;
    var qty=pairs(cart);
    var g=giftLine(cart);
    var url,body;

    if(qty>=1 && !g){ url='/cart/add.js'; body={id:GIFT_ID,quantity:1}; }
    else if(qty<1 && g){ url='/cart/change.js'; body={id:String(GIFT_ID),quantity:0}; }
    else if(g && g.quantity!==1){ url='/cart/change.js'; body={id:String(GIFT_ID),quantity:1}; }
    else { return; }

    lock=true;
    fetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})
      .then(function(r){return r.json();})
      .then(function(){ setTimeout(function(){ lock=false; reloadDrawer(); },180); })
      .catch(function(){ lock=false; });
  }

  function read(){
    fetch('/cart.js',{cache:'no-store'})
      .then(function(r){return r.json();})
      .then(function(cart){
        var sig=cart.item_count+'|'+cart.items.map(function(i){return i.variant_id+':'+i.quantity;}).join(',');
        paint(cart);
        if(sig!==lastSig){ lastSig=sig; syncGift(cart); }
      })
      .catch(function(){});
  }

  function timer(){
    if(window.__ssT) return;
    var el=document.getElementById('sscoTimer'); if(!el) return;
    var K='ss_res',end=sessionStorage.getItem(K);
    if(!end||+end<Date.now()){end=Date.now()+300000;sessionStorage.setItem(K,end);}
    end=+end;
    window.__ssT=setInterval(function(){
      var t=document.getElementById('sscoTimer');
      if(!t){clearInterval(window.__ssT);window.__ssT=null;return;}
      var d=Math.max(0,end-Date.now());
      if(d===0){end=Date.now()+300000;sessionStorage.setItem(K,end);d=300000;}
      var m=Math.floor(d/60000),s=Math.floor((d%60000)/1000);
      t.textContent=(m<10?'0':'')+m+':'+(s<10?'0':'')+s;
    },1000);
  }

  function loop(){ timer(); read(); }

  ['cart:change','cart:updated','cart:update','cart:refresh','variant:add','cart:build'].forEach(function(e){
    document.addEventListener(e,function(){ setTimeout(read,400); });
    document.documentElement.addEventListener(e,function(){ setTimeout(read,400); });
  });

  document.addEventListener('click',function(e){
    if(e.target.closest&&e.target.closest('button, [type="submit"], cart-drawer-component')){
      setTimeout(read,600);
      setTimeout(read,1200);
    }
  },true);

  document.addEventListener('DOMContentLoaded',loop);
  (function(){var of=window.fetch;window.fetch=function(u){var url=String(u&&u.url||u);var p=of.apply(this,arguments);if(/\/cart\/(add|change|update|clear)/.test(url)){p.then(function(){setTimeout(read,300);setTimeout(read,1200)},function(){})}return p}})();
  loop();
})();